import page from 'page'
import React from 'react'
import moment from 'moment'
import numeral from 'numeral'
import { FormattedMessage } from 'react-intl'

import Link from '../../components/Link'
import DangerSvg from '../../components/Icons/Danger'

const BidHistory = ({ info, lot, items = [], id, subtitle, title, emptyTitle, user, noLink = false, noDate = false, isExpand = false, showBids, show, onExpand, nextBid, timer, CTAButton, urlPrefix = 'members' }) =>(
  <section>
    {/* {subtitle && <span className='Label'>{subtitle}</span>} */} {/* всего # ставок */} 
    {(title && items && (items.length > 0)) && <h1 className='Main__title Head LastBidTitle'>{title}</h1>}
    {subtitle && <span className='Main__founds-price Text DoneBids' style={{cursor: "pointer"}} onClick={showBids}>{subtitle}</span>} 
    {(emptyTitle && !items.length) && <h1 className='Main__title Head'>{emptyTitle}</h1>}

    {items.length > 0 && show && (
      <div className='Text Main__founds-list'>
        {items.map(el => {
          const isMe = user && el.targetId === user._id
          const isBroken = isMe && lot.paymentRequired && !el.userPaymentId //восклицательный знак в списке ставок лотов
          && (el.value !== el.giftcardValue) && (el.value !== el.holdGiftcard) && ((el.giftcardValue !== 0) || (el.holdGiftcard !== 0))//требуется платеж, но он не привязан к банк карте и при этом не оплачен подарочной картой
          let onClick
          if (isBroken) onClick = () => page(`/lots/${id}/bid/${el._id}`)

          return (
            <div className={['Main__founds-item', el.isWinner ? 'Winner' : (isMe ? 'Orange' : 'BidsGray'), isBroken ? 'Pointer' : ''].join(' ')} key={el._id} onClick={onClick}>
              <span className='Main__table-column-costName'><nobr>{el.sum ? numeral(el.sum).format('0,0') : 0} {el.currency}</nobr></span>
              <span className='Main__table-column-costName'>
                {(el.name && noLink) && (isMe ? (<FormattedMessage id='bid_history.you' />) : el.name)}
                {(el.name && !noLink) && <Link className='Link Link_orange' to={`/${urlPrefix}/${el.targetId}`}>{isMe ? <FormattedMessage id='bid_history.you' /> : el.name}</Link>}
                {(el.date && !noDate) /*&& `, ${moment(el.date).format('D MMMM')}`*/}
              </span>
              <span className='Main__table-column-dateTime'>{moment(el.date).format('DD.MM.YYYY ')}</span>
              <span className='Main__table-column-dateTime'>{moment(el.date).format('HH:mm')}</span>
              {isBroken && <span style={{ marginLeft: 12 }}><DangerSvg /></span>}
            </div>
          )
          
        })}

        
      </div>
    )}
    {/* {(onExpand && isExpand && showBids) && (<button className='Main__founds-more Text Link Link_single' onClick={showBids}><FormattedMessage id='bid_history.show_more' /></button>)} */}
    {nextBid && lot.status !== 'complete' &&
      (<span className="SubHead"><FormattedMessage id='lot.next_bid' />: {nextBid}</span>)
    }
    <div style={{marginTop: '50px', marginBottom: '50px'}}>
      {timer && timer}
      {CTAButton && CTAButton}
    </div>
  </section>
)

export default BidHistory



// WEBPACK FOOTER //
// ./src/components/Lot/BidHistory.jsx